import React from 'react';
import HeaderBackground from '../../assets/images/header-background.jpg'

const HeaderBackgroundImg = () => {
   return <img src={HeaderBackground} alt="Vestige Background Image" />
}

export default HeaderBackgroundImg;